const validatorStringInput = (
	value: string,
	args: {
		fieldName: string;
		isRequired: boolean;
		isDisabled: boolean;
	}
): string[] => {
	const returnArr: string[] = [];

	if (args.isRequired && value.length === 0) {
		returnArr.push('Dit veld is verplicht.');
	}
	else if (args.isDisabled) {
		returnArr.push('Dit veld kan niet gewijzigd worden.');
	}

	return returnArr;
};

export default validatorStringInput;
